// extracted by mini-css-extract-plugin
export default {"bracket":"Winner_bracket--DH3","winner":"Winner_winner--z7a","title":"Winner_title--iCA"};